<template>
  <layout
    title="Skireisen, Skiurlaub, Wintersport, Gruppenreisen"
    :banner="$page.props.banner"
    metaDescription="Wenn es um Skiurlaub mit der Familie, Skispaß mit Freunden oder Winterurlaub zu zweit in den wunderschönen Skigebieten Österreichs geht, dann bist du bei SCOL genau richtig. Gruppenreisen für Skifans sind unsere Spezialität und das seit über 30 Jahren."
    metaKeywords="SCOL, SCOL Skireisen, Skireise Gruppe, Skifahren Gruppe, Skifahren, Skireise buchen, Skifahren, Ski, Skiurlaub, Skiurlaub buchen, Skifahren Österreich, Skifahren Italien"
  >
    <!-- Wetter Info Teaser -->
    <!-- <section class="scol-section py-4" style="background: linear-gradient(135deg, #4a90e2, #5ba3f5); box-shadow: 0 4px 15px rgba(0,0,0,0.1);">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="text-center text-white">
              <div class="mb-2">
                <i class="fas fa-info-circle fa-2x"></i>
              </div>
              <h4 class="fw-bold mb-3">Liebe Gäste,</h4>
              <p class="mb-2 fs-5">
                wir beobachten die aktuelle Wetterlage gemeinsam mit unseren erfahrenen Busunternehmen. Aktuell sehen wir keine Gefahr, heute Abend die Busse Richtung Alpen zu schicken.
              </p>
              <p class="mb-0 fw-bold">
                Grüße,<br>
                euer SCOL Team
              </p>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Hero-Overlay: bis 15.08.2026 Gewinnspiel-Banner, danach Kontakt-Banner -->
    <template #banner-overlay>
      <div v-if="gewinnspielLaeuft && showGewinnspiel" class="gewinnspiel-hero">
        <a
          :href="gewinnspiel.url"
          class="gewinnspiel-banner"
          target="_blank"
          rel="noopener"
        >
          <div
            class="d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 gap-md-4"
          >
            <div class="text-center text-md-start">
              <h3 class="gewinnspiel-banner__title text-white fw-bold mb-1">
                {{ gewinnspiel.title }}
              </h3>
              <p
                class="gewinnspiel-banner__text text-white mb-1"
                style="opacity: 0.9;"
              >
                {{ gewinnspiel.text }}
              </p>
              <p class="gewinnspiel-banner__deadline text-white fw-semibold mb-0">
                Mitmachen bis {{ gewinnspiel.deadline }}
              </p>
            </div>
            <div class="flex-shrink-0 text-center">
              <span class="btn btn-light btn-lg rounded-pill px-4 fw-bold shadow">
                Zum Gewinnspiel &rarr;
              </span>
            </div>
          </div>
        </a>
        <button
          type="button"
          class="gewinnspiel-banner__close"
          aria-label="Banner schließen"
          @click="closeGewinnspiel"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div
        v-else-if="!gewinnspielLaeuft && showKontakt"
        class="gewinnspiel-hero"
      >
        <div class="gewinnspiel-banner">
          <div
            class="d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 gap-md-4"
          >
            <div class="text-center text-md-start">
              <h3 class="gewinnspiel-banner__title text-white fw-bold mb-1">
                Fragen zur Skireise?
              </h3>
              <p
                class="gewinnspiel-banner__text text-white mb-1"
                style="opacity: 0.9;"
              >
                Dann ruf uns an:
                <a class="kontakt-banner__link" href="tel:+49443596000">
                  04435 96000
                </a>, schreib uns eine E-Mail an
                <a class="kontakt-banner__link" href="mailto:info@scol.de">
                  info@scol.de
                </a>
                oder komm einfach bei uns vorbei.
              </p>
              <p class="gewinnspiel-banner__deadline text-white fw-semibold mb-0">
                Mo–Fr von 09:00 bis 17:00 Uhr sind wir für dich da.
              </p>
            </div>
            <div class="flex-shrink-0 text-center">
              <a
                href="tel:+49443596000"
                class="btn btn-light btn-lg rounded-pill px-4 fw-bold shadow"
              >
                <i class="fas fa-phone-alt me-2"></i> Anrufen
              </a>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="gewinnspiel-banner__close"
          aria-label="Banner schließen"
          @click="closeKontakt"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </template>

    <!-- Winter 26/27 Pop-Up -->
    <div
      id="winter-2627-modal"
      ref="winterModal"
      class="modal fade"
      tabindex="-1"
      aria-labelledby="winter-2627-modal-title"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content rounded-4 shadow border-0 overflow-hidden">
          <div
            class="position-relative text-white text-center px-4 px-md-5 pt-5 pb-4"
            style="background: linear-gradient(135deg, #4a90e2, #5ba3f5);"
          >
            <button
              type="button"
              class="btn-close btn-close-white position-absolute"
              style="top: 1rem; right: 1rem;"
              data-bs-dismiss="modal"
              aria-label="Schließen"
            ></button>
            <i class="fas fa-snowflake fa-3x mb-3" style="opacity: 0.9;"></i>
            <h2 id="winter-2627-modal-title" class="fw-bold mb-2 text-white">
              Winter 26/27 – jetzt online!
            </h2>
            <p class="mb-0 fs-5" style="opacity: 0.95;">
              Unser komplettes Programm für die kommende Skisaison ist da.
            </p>
            <div
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; pointer-events: none;"
            >
              <i
                class="fas fa-snowflake fa-lg"
                style="position: absolute; top: 18%; left: 8%; color: rgba(255,255,255,0.25); animation: float 3s ease-in-out infinite;"
              ></i>
              <i
                class="fas fa-snowflake"
                style="position: absolute; bottom: 18%; right: 8%; color: rgba(255,255,255,0.2); animation: float 4s ease-in-out infinite 1s;"
              ></i>
              <i
                class="fas fa-snowflake fa-sm"
                style="position: absolute; top: 25%; right: 18%; color: rgba(255,255,255,0.2); animation: float 3.5s ease-in-out infinite 0.5s;"
              ></i>
            </div>
          </div>
          <div class="modal-body text-center p-4 p-md-5">
            <p class="fs-5 mb-3">
              Von gemütlich bis sportlich, vom Familienurlaub bis zur
              <strong>Party on Snow</strong> – wählt aus unseren Skizielen in
              Österreich und Südtirol:
            </p>
            <div class="d-flex flex-wrap justify-content-center gap-2 mb-4">
              <template
                v-for="dest in destinations"
                :key="'dest-' + dest.label"
              >
                <a
                  v-if="isLinkable(dest)"
                  :href="$route('travel-destination', dest.code)"
                  class="badge rounded-pill bg-light text-dark border px-3 py-2 destination-badge text-decoration-none"
                  @click="closeWinterModal"
                >
                  {{ dest.label }}
                  <i class="fas fa-chevron-right ms-1" style="font-size: 0.7em;"></i>
                </a>
                <span
                  v-else
                  class="badge rounded-pill bg-light text-dark border px-3 py-2"
                >
                  {{ dest.label }}
                </span>
              </template>
            </div>
            <p class="text-muted mb-4">
              Alle Termine, Preise und Leistungen findet ihr in unserem
              Programm-PDF.
            </p>
            <div class="d-flex flex-column flex-sm-row flex-wrap gap-3 justify-content-center">
              <!-- <a
                href="/files/pdf/scol-skireisen-reisen-26-27.pdf?v=3?v=2"
                target="_blank"
                class="btn btn-primary btn-lg rounded-pill px-4 fw-bold"
                @click="closeWinterModal"
              >
                <i class="fas fa-file-pdf me-2"></i>
                Programm 26/27 ansehen
              </a> -->
              <Link
                :href="$route('contact')"
                class="btn btn-success btn-lg rounded-pill px-4 fw-bold"
                @click="closeWinterModal"
              >
                <i class="fas fa-tags me-2"></i>
                Jetzt Angebot sichern!
              </Link>
              <button
                type="button"
                class="btn btn-outline-secondary btn-lg rounded-pill px-4"
                data-bs-dismiss="modal"
              >
                Später ansehen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section id="skiurlaub" class="scol-section bg-light">
      <div class="scol-section-caption d-sm-none">
        <h1 class="h2 text-white mb-0">SCOL Skireisen</h1>
      </div>
      <div class="d-sm-none container">
        <p class="display-3 text-secondary headings-font-family text-center">
          Komfortabel. Familiengerecht.
        </p>
        <p class="text-center my-3">
          Jetzt Urlaub finden und direkt bei SCOL Skireisen buchen:
        </p>
      </div>
      <div class="scol-vacation-search">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-md-10 col-xxl-7 position-relative">
              <form id="search-travel" @submit.prevent="searchTravel">
                <div class="row">
                  <div class="col-sm-6 col-lg-3 mb-lg-0 mb-2">
                    <locations
                      v-model:search="form.l"
                      v-model:code="form.code"
                      input-class="form-control-lg form-control-icon form-control-map rounded-pill"
                      :locations="searchLocations"
                    />
                  </div>
                  <div class="col-sm-6 col-lg-3 mb-lg-0 mb-2">
                    <Datepicker
                      v-model="form.r"
                      range
                      placeholder="Reisezeitraum (Winter)..."
                      inputClassName="form-control form-control-lg rounded-pill"
                      locale="de-DE"
                      :format="datepickerFormat"
                      multi-calendars
                      auto-apply
                      :enable-time-picker="false"
                      :min-date="seasonStart"
                      :max-date="seasonEnd"
                      :start-date="seasonStart"
                      :markers="markers"
                      prevent-min-max-navigation
                    />
                    <small class="d-block text-muted mt-1 ms-2 search-date-legend">
                      <span class="legend-dot legend-dot--arrival"></span> Anreise
                      <span class="legend-dot legend-dot--departure ms-2"></span> Abreise
                      <span class="legend-dot legend-dot--both ms-2"></span> beides
                    </small>
                  </div>
                  <div class="col-sm-6 col-lg-3 mb-lg-0 mb-2">
                    <div ref="persons" class="position-relative">
                      <input
                        type="text"
                        class="form-control form-control-lg form-control-icon form-control-person rounded-pill"
                        placeholder="Personenanzahl..."
                        :value="personsValue"
                        @click="togglePersons"
                      />
                      <div
                        v-if="showPersons"
                        id="persons-popover"
                        class="position-absolute top-100 end-0 shadow rounded bg-white p-3"
                        style="min-width: 400px"
                      >
                        <ul class="list-unstyled mb-0">
                          <li
                            class="d-flex justify-content-between align-items-center mb-3"
                          >
                            <span>Erwachsene</span>
                            <span class="d-flex align-items-center">
                              <button
                                type="button"
                                class="btn btn-sm btn-link"
                                @click="removeAdult"
                                :disabled="!form.p.a"
                              >
                                <i class="bi bi-dash-circle"></i>
                              </button>
                              <span
                                class="text-center"
                                style="min-width: 3rem"
                                >{{ form.p.a }}</span
                              >
                              <button
                                type="button"
                                class="btn btn-sm btn-link"
                                @click="addAdult"
                                :disabled="form.p.a == maxAdults"
                              >
                                <i class="bi bi-plus-circle"></i>
                              </button>
                            </span>
                          </li>
                          <li
                            class="d-flex justify-content-between align-items-center"
                          >
                            <span class="lh-1"
                              >Kinder<br /><small class="text-muted"
                                >bis 18 Jahre</small
                              ></span
                            >
                            <span class="d-flex align-items-center">
                              <button
                                type="button"
                                class="btn btn-sm btn-link"
                                @click="removeChild"
                                :disabled="!form.p.c"
                              >
                                <i class="bi bi-dash-circle"></i>
                              </button>
                              <span
                                class="text-center"
                                style="min-width: 3rem"
                                >{{ form.p.c }}</span
                              >
                              <button
                                type="button"
                                class="btn btn-sm btn-link"
                                @click="addChild"
                                :disabled="form.p.c == maxChilds"
                              >
                                <i class="bi bi-plus-circle"></i>
                              </button>
                            </span>
                          </li>
                        </ul>
                        <div v-if="form.p.c" class="mt-1">
                          <div
                            class="row row-cols-1 row-cols-md-2 gx-3 gy-1 mb-1"
                          >
                            <div
                              v-for="(nr, i) in form.p.c"
                              :key="'ages-child-' + nr"
                              class="col"
                            >
                              <select
                                v-model="form.ages[i]"
                                class="form-select form-select-sm"
                                aria-label="Alter benötigt"
                              >
                                <option :value="null">Alter benötigt</option>
                                <option
                                  v-for="(k, age) in 19"
                                  :key="'ages-child-options-' + age"
                                  :value="age"
                                >
                                  {{ age }} Jahre alt
                                </option>
                              </select>
                            </div>
                          </div>
                          <p class="lh-1 text-muted">
                            <small
                              >Wir benötigen das Alter zum Reisebeginn.</small
                            >
                          </p>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center mt-3"
                        >
                          <span>Zimmer</span>
                          <span class="d-flex align-items-center">
                            <button
                              type="button"
                              class="btn btn-sm btn-link"
                              @click="removeRoom"
                              :disabled="!form.z"
                            >
                              <i class="bi bi-dash-circle"></i>
                            </button>
                            <span class="text-center" style="min-width: 3rem">{{
                              form.z
                            }}</span>
                            <button
                              type="button"
                              class="btn btn-sm btn-link"
                              @click="addRoom"
                              :disabled="form.z == maxRooms"
                            >
                              <i class="bi bi-plus-circle"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                    <button
                      type="submit"
                      class="btn btn-lg btn-primary w-100 rounded-pill text-light btn-search-vacation"
                    >
                      <i class="fas fa-search"></i> Urlaub suchen
                    </button>
                  </div>
                </div>

                <input type="hidden" v-model="form.tid" />
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="container text-center introduction">
        <h1 class="text-primary d-none d-sm-block">
          Einfach in den Skiurlaub.
        </h1>
        <p
          class="mt-3 mb-4 mb-md-0 display-3 text-secondary headings-font-family d-none d-sm-block"
        >
          Komfortabel. Familiengerecht.
        </p>
      </div>
    </section>

    <section id="aktuelle-angebote" class="scol-section">
      <div class="scol-section-caption">
        <!-- <h2>Aktuelle Angebote</h2> -->
        <h2>Liebe SCOL Gäste,</h2>
      </div>

      <div class="container-large">
        <div class="row justify-content-center mb-5 gx-lg-5">
          <div class="col-xl-6 text-center">
            <p>
              schön, dass ihr bei uns „gelandet“ seid. Schaut euch gerne um und wenn Fragen auftauchen, gerne melden.
            </p>
            <Link
              :href="$route('contact')"
              class="btn btn-outline-secondary mt-3 rounded-pill"
            >
              Kontakt
            </Link>
            <div class="mt-4 text-center text-primary">
              <h3>Skireisen in der Gruppe - das ist SCOL!</h3>
              <!-- <h3>Bis demnächst, euer SCOL Team</h3> -->
            </div>
          </div>
        </div>

        <div class="row g-4 g-xxl-5">
          <div
            class="col-sm-6 col-lg-4 col-xl-3"
            v-for="deal in deals"
            :key="'deal-' + deal.id"
          >
            <scol-travel-preview :model="deal" />
          </div>

          <div
            v-for="promo in promos"
            :key="'promo-' + promo.routeName"
            class="col-sm-6 col-lg-4 col-xl-3"
          >
            <scol-promo-preview
              :title="promo.title"
              :text="promo.text"
              :image="promo.image"
              :route-name="promo.routeName"
            />
          </div>
        </div>

        <div class="text-center mt-4 mt-md-5">
          <Link
            :href="$route('vacation')"
            class="btn btn-outline-secondary btn-lg rounded-pill"
          >
            <i class="fas fa-skiing me-2"></i> Alle Reisen
          </Link>
        </div>
      </div>
    </section>

    <section id="ueber-uns" class="scol-section">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-xxl-4 col-lg-6 col-md-8 text-center">
            <div class="inner">
              <h2>Deine Skireise</h2>
              <h5>mit SCOL.</h5>
              <p>Lerne uns kennen.</p>
              <Link
                :href="$route('about-us')"
                class="btn btn-white btn-lg rounded-pill mt-3"
              >
                <i class="fas fa-user-friends"></i> Über uns
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="info" class="scol-section bg-vacation-blue">
      <div class="container-large">
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-4 mb-4">
            <div class="info-card">
              <div class="bg">
                <div class="inner inner-simon">
                  <h3>Infos</h3>
                  <h5 class="font-family-base">
                    für Reiseleiter & Gruppenreisen
                  </h5>
                  <p class="lh-sm my-2">Ich bin Simon - dein Ansprechpartner</p>
                  <div class="row">
                    <div class="col-sm-4 col-md-12 col-xxl-4">
                      <img
                        class="rounded-circle border border-light border-3"
                        src="/images/scol-simon.jpg"
                        alt="Simon"
                      />
                    </div>
                    <div class="col-sm-7 col-md-12 col-xxl-8">
                      <ul class="list-unstyled mt-3">
                        <li class="mb-3">
                          <a
                            href="tel:+49443596000"
                            class="btn btn-home rounded-pill btn-outline-blue-dark"
                          >
                            <i class="fas fa-phone-alt"></i> Simon anrufen
                          </a>
                        </li>
                        <li>
                          <a
                            href="mailto:info@scol.de"
                            class="btn btn-home rounded-pill btn-outline-blue-dark"
                          >
                            <i class="fas fa-envelope"></i> Simon mailen
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-4">
            <div class="info-card">
              <div class="bg">
                <div class="inner">
                  <h3 class="mb-0">Anreiseinfos</h3>
                  <p class="my-4 px-xl-5">
                    Lies hier die wichtigesten Infos für unsere
                    Anreisen/Abreisen.
                  </p>
                  <Link
                    :href="$route('arrival')"
                    class="btn btn-home rounded-pill btn-outline-blue-dark"
                  >
                    <i class="fas fa-eye"></i> Infos ansehen
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="info-card">
              <div class="bg">
                <div class="inner">
                  <h3 class="mb-0">Orte</h3>
                  <p class="my-4 px-xl-5">
                    Stöber dich durch die Urlaubsorte und finde deinen perfekten
                    Skiurlaub.
                  </p>
                  <Link
                    :href="$route('vacation')"
                    class="btn btn-home rounded-pill btn-outline-blue-dark"
                  >
                    <i class="fas fa-eye"></i> Urlaubsorte ansehen
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="kundenstimmen" class="scol-section overflow-hidden">
      <div class="container text-center">
        <h2 class="mb-4">Kundenstimmen</h2>
        <div class="elfsight-app-aade707a-a8c7-45a0-b592-89e1a5cfff69">
          <p>
            Auf dieser Seite werden externe Inhalte geladen.<br />
            Mit einem Klick auf "Bestätigen" werden Cookies gesetzt sowie der
            Inhalt geladen.<br />
            Zur Darstellung wird Inhalt von Elfsight verwendet.<br />
            Weitere Informationen finden Sie in unserer
            <Link :href="$route('data-protection')">Datenschutzerklärung </Link
            >.
          </p>
          <button
            type="button"
            onclick="addCookieValue('elfsight')"
            class="btn btn-primary"
          >
            Bestätigen
          </button>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import { Link, useForm } from "@inertiajs/inertia-vue3";
import Datepicker from "@vuepic/vue-datepicker";
import Locations from "../Components/Scol/Locations";
import ScolTravelPreview from "../Components/Scol/TravelPreview";
import ScolPromoPreview from "../Components/Scol/PromoPreview";
import ScolSearch from "../Models/Search";
import { onClickOutside } from "@vueuse/core";

export default {
  components: {
    Layout,
    Link,
    Datepicker,
    Locations,
    ScolTravelPreview,
    ScolPromoPreview,
  },
  props: {
    searchLocations: Object,
    deals: Object,
    destinationCodes: {
      type: Array,
      default: () => [],
    },
    // An-/Abreise-Marker für den Kalender (kommen aus dem PageController).
    searchMarkers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // Gewinnspiel-Banner im Hero. URL ggf. anpassen.
      gewinnspiel: {
        title: "Gewinnspiel: Eine Woche All-inclusive zu zweit",
        text: "Gewinne deinen Sommerurlaub im 4★ SCOL Sporthotel Zillertal, im Wert von über 1.000 Euro.",
        deadline: "15.08.2026",
        url: "https://scol.at/gewinnspiel",
      },
      // Steuert die Sichtbarkeit des Gewinnspiel-Banners (per "X" ausblendbar).
      showGewinnspiel: true,
      // Steuert die Sichtbarkeit des Kontakt-Banners (per "X" ausblendbar).
      showKontakt: true,
      // Statische Promo-Kacheln, die ans Ende der Angebots-Reihe gehängt werden.
      // Bilder ggf. austauschen (public/images/).
      promos: [
        {
          title: "Gruppenreisen 26/27",
          text: "Ihr seid eine Gruppe ab 8 Personen? Wir stellen euch gerne ein individuelles Angebot zusammen – sendet uns eure unverbindliche Anfrage.",
          image: "/images/scol-skireisen-skifahrer-berge.jpg",
          routeName: "group-travel",
        },
        {
          title: "Zukünftige Reiseziele 27/28",
          text: "Euer Wunsch-Skigebiet fehlt im Programm? Sagt es uns – wir prüfen, ob wir euer Traumziel für die Saison 27/28 aufnehmen.",
          image: "/images/scol-skireisen-header-angebote-skigebiet.jpg",
          routeName: "future-destinations",
        },
      ],
      showPersons: false,
      maxAdults: 10,
      maxChilds: 10,
      maxRooms: 10,
      // Wintersaison 26/27: nur dieser Zeitraum ist im Kalender wählbar.
      // (Monat ist 0-basiert: 11 = Dezember, 3 = April.)
      seasonStart: new Date(2026, 11, 5), // 05.12.2026
      seasonEnd: new Date(2027, 3, 3), // 03.04.2027
      form: useForm(ScolSearch.defaults()),
      // Ziele aus dem Pop-Up. `code` = TravelInfo-Code der Zielseite;
      // Ziele ohne `code` (bzw. ohne Detailseite) bleiben als nicht-klickbares
      // Badge stehen.
      destinations: [
        { label: "Kals", code: "KALS" },
        { label: "Fügen / Zillertal", code: "FUEGEN" },
        { label: "Sölden", code: "SOELDEN" },
        { label: "Corvara", code: "CORVARA" },
        { label: "Serfaus", code: "SER" },
        { label: "Ischgl", code: "ISCHGL" },
        { label: "Bad Hofgastein", code: "HOFGAST" },
        { label: "St. Anton am Arlberg", code: null },
        { label: "Kaprun", code: null },
      ],
    };
  },
  watch: {
    form: {
      handler(value) {
        const data = {
          l: value.l,
          r: value.r,
          p: value.p,
          ages: value.ages,
          tid: value.tid,
          code: value.code,
          z: Math.min(value.z, value.p.a),
        };
        this.form.z = data.z;
        ScolSearch.putSessionStorage(data);
      },
      deep: true,
    },
  },
  // TODO: Watcher reset location on type
  methods: {
    searchTravel() {
      //   console.log("test");
      this.form.get(this.$route("search-results"), {
        // preserveScroll: true,
        onSuccess: () => this.form.reset("location"),
      });
    },
    togglePersons() {
      this.showPersons = !this.showPersons;
    },
    addAdult() {
      if (this.form.p.a == this.maxAdults) {
        return;
      }
      this.form.p.a++;
    },
    removeAdult() {
      if (this.form.p.a == 1) {
        return;
      }
      this.form.p.a--;
    },
    addChild() {
      if (this.form.p.c == this.maxChilds) {
        return;
      }
      this.form.p.c++;
    },
    removeChild() {
      if (!this.form.p.c) {
        return;
      }
      this.form.p.c--;
    },
    addRoom() {
      if (this.form.z == this.form.p.a || this.form.z == this.maxRooms) {
        return;
      }
      this.form.z++;
    },
    removeRoom() {
      if (this.form.z == 1) {
        return;
      }
      this.form.z--;
    },
    closeWinterModal() {
      const el = this.$refs.winterModal;
      if (el && window.bootstrap) {
        bootstrap.Modal.getOrCreateInstance(el).hide();
      }
    },
    closeGewinnspiel() {
      this.showGewinnspiel = false;
      try {
        localStorage.setItem("gewinnspiel-banner-hidden", "1");
      } catch (e) {
        // localStorage nicht verfügbar – Banner bleibt nur für diese Sitzung aus.
      }
    },
    closeKontakt() {
      this.showKontakt = false;
      try {
        localStorage.setItem("kontakt-banner-hidden", "1");
      } catch (e) {
        // localStorage nicht verfügbar – Banner bleibt nur für diese Sitzung aus.
      }
    },
    isLinkable(dest) {
      return !!dest.code && this.destinationCodes.includes(dest.code);
    },
    datepickerFormat: (range) => {
      //   console.log(range[0], range[1]);
      const options = { weekday: "short", month: "short", day: "numeric" };
      const date1 = new Date(range[0]);
      const from =
        date1.toLocaleDateString("de-DE", { weekday: "short" }) +
        ", " +
        date1.toLocaleDateString("de-DE", { month: "short", day: "numeric" });
      const date2 = new Date(range[1]);
      const to =
        date2.toLocaleDateString("de-DE", { weekday: "short" }) +
        ", " +
        date2.toLocaleDateString("de-DE", { month: "short", day: "numeric" });
      return `${from} - ${to}`;
    },
  },
  mounted() {
    if (getCookieValue("elfsight") == true) {
      let elfsightJs = document.createElement("script");
      elfsightJs.setAttribute("src", "https://apps.elfsight.com/p/platform.js");
      document.head.appendChild(elfsightJs);
    }

/*     if (getCookieValue("googleanalytics") == true) {
      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");

      script.text =
        "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
        "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
        "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
        "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
        "})(window,document,'script','dataLayer','GTM-PSGCN7PH');";

      head.insertBefore(script, head.firstChild);

      var body = document.getElementsByTagName("body")[0];
      var noscript = document.createElement("noscript");

      var iframe = document.createElement("iframe");
      iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-PSGCN7PH";
      iframe.height = "0";
      iframe.width = "0";
      iframe.style.display = "none";
      iframe.style.visibility = "hidden";

      noscript.appendChild(iframe);

      body.insertBefore(noscript, body.firstChild);
    } */

    this.search = new ScolSearch().fromStorage();
    const form = this.search.data;
    if (form && form.l) {
      this.form.l = form.l;
    }
    if (form && form.r) {
      this.form.r = form.r;
    }
    if (form && form.p) {
      this.form.p = form.p;
    }
    if (form && form.ages) {
      this.form.ages = form.ages;
    }
    if (form && form.tid) {
      this.form.tid = form.tid;
    }
    if (form && form.code) {
      this.form.code = form.code;
    }
    if (form && form.z) {
      this.form.z = form.z;
    }
    this.form.defaults().reset();

    onClickOutside(this.$refs.persons, (event) => {
      this.showPersons = false;
    });

    // Banner ausgeblendet lassen, wenn zuvor per "X" geschlossen.
    try {
      if (localStorage.getItem("gewinnspiel-banner-hidden") === "1") {
        this.showGewinnspiel = false;
      }
      if (localStorage.getItem("kontakt-banner-hidden") === "1") {
        this.showKontakt = false;
      }
    } catch (e) {
      // localStorage nicht verfügbar – Banner wird angezeigt.
    }

  /*  if (!sessionStorage.getItem("winter-2627-modal-seen")) {
      setTimeout(() => {
        const el = this.$refs.winterModal;
        if (el && window.bootstrap) {
          bootstrap.Modal.getOrCreateInstance(el).show();
          sessionStorage.setItem("winter-2627-modal-seen", "1");
        }
      }, 800);
    }*/
  },
  computed: {
    // Gewinnspiel läuft bis einschließlich 15.08.2026, danach zeigt der Hero
    // den Kontakt-Banner.
    gewinnspielLaeuft() {
      return new Date() < new Date(2026, 7, 16, 0, 0, 0);
    },
    personsValue() {
      return ScolSearch.personsReadable(this.form);
    },
    // vue-datepicker erwartet Date-Objekte für die Marker-Daten.
    markers() {
      return this.searchMarkers.map((marker) => ({
        ...marker,
        date: new Date(marker.date),
      }));
    },
  },
};
</script>

<style scoped>
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.animate-pulse {
  animation: pulse 2s infinite;
}

.destination-badge {
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease,
    border-color 0.15s ease, transform 0.15s ease;
}
.destination-badge:hover,
.destination-badge:focus-visible {
  background-color: #4a90e2 !important;
  border-color: #4a90e2 !important;
  color: #fff !important;
  transform: translateY(-1px);
}

.search-date-legend {
  font-size: 0.75rem;
}
.legend-dot {
  display: inline-block;
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 0.2rem;
}
.legend-dot--arrival {
  background-color: #198754;
}
.legend-dot--departure {
  background-color: #dc3545;
}
.legend-dot--both {
  background-color: #fd7e14;
}

/* Mobil-first: kompakt halten. Positionierung übernimmt .hero-stoerer-stack */
.winter-stoerer {
  padding: 14px 16px;
  border-radius: 14px;
}
.winter-stoerer__title {
  font-size: 1.1rem;
  line-height: 1.25;
}
.winter-stoerer__text {
  font-size: 0.78rem;
  line-height: 1.35;
}
.winter-stoerer .btn {
  font-size: 0.85rem;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

/* Tablet */
@media (min-width: 768px) {
  .winter-stoerer {
    padding: 24px 30px;
    border-radius: 20px;
  }
  .winter-stoerer__title {
    font-size: 1.6rem;
  }
  .winter-stoerer__text {
    font-size: 0.98rem;
    line-height: 1.45;
  }
  .winter-stoerer .btn {
    font-size: 1.05rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}

/* Desktop */
@media (min-width: 992px) {
  .winter-stoerer {
    padding: 28px 36px;
  }
  .winter-stoerer__title {
    font-size: 1.9rem;
  }
}

/* Hero-Banner (Gewinnspiel bzw. Kontakt) im Winter-26/27-Look
   (blauer Verlauf, weiße Schrift) */

/* Wrapper: positioniert Banner + Schließen-X über dem Titelbild.
   Mobil-first: etwas unterhalb der Mitte, damit oben Luft zum Header bleibt. */
.gewinnspiel-hero {
  position: absolute;
  left: 50%;
  top: 54%;
  transform: translate(-50%, -50%);
  width: 92%;
  max-width: 860px;
  z-index: 1040;
}

.gewinnspiel-banner {
  display: block;
  width: 100%;
  text-decoration: none;
  background: linear-gradient(
    135deg,
    rgba(74, 144, 226, 0.92),
    rgba(91, 163, 245, 0.92)
  );
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  /* kompakt (mobil); Positionierung übernimmt .gewinnspiel-hero */
  padding: 14px 16px;
  padding-right: 34px; /* Platz für das Schließen-X */
}
a.gewinnspiel-banner:hover,
a.gewinnspiel-banner:focus-visible {
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.42);
  transform: translateY(-2px);
}

.gewinnspiel-banner__title {
  font-size: 1.1rem;
  line-height: 1.2;
}
.gewinnspiel-banner__text {
  font-size: 0.8rem;
  line-height: 1.3;
}
.gewinnspiel-banner__deadline {
  font-size: 0.82rem;
}
.gewinnspiel-banner .btn-light {
  white-space: nowrap;
}

/* Telefon-/E-Mail-Link im Kontakt-Banner */
.kontakt-banner__link {
  color: #fff;
  text-decoration: underline;
  white-space: nowrap;
}
.kontakt-banner__link:hover,
.kontakt-banner__link:focus-visible {
  color: #fff;
  text-decoration: none;
}

/* Schließen-X */
.gewinnspiel-banner__close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 0.85rem;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.15s ease;
  z-index: 3;
}
.gewinnspiel-banner__close:hover,
.gewinnspiel-banner__close:focus-visible {
  background-color: rgba(255, 255, 255, 0.5);
}

/* Tablet */
@media (min-width: 768px) {
  .gewinnspiel-hero {
    top: 56%;
  }
  .gewinnspiel-banner {
    padding: 22px 30px;
    padding-right: 44px;
    border-radius: 20px;
  }
  .gewinnspiel-banner__title {
    font-size: 1.5rem;
  }
  .gewinnspiel-banner__text {
    font-size: 0.95rem;
  }
  .gewinnspiel-banner__deadline {
    font-size: 0.95rem;
  }
}

/* Desktop */
@media (min-width: 992px) {
  .gewinnspiel-hero {
    top: 58%;
  }
}
</style>
